import React from 'react';

const IconLogo = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 84 96">
    <title>S Logo</title>
    <g transform="translate(-8.000000, -2.000000)">
      <g transform="translate(11.000000, 5.000000)">
        {/* Hexagon outline */}
        <polygon
          id="Shape"
          stroke="currentColor"
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
          points="39 0 0 22 0 67 39 90 78 68 78 23"
        />
        <g transform="translate(28, 26) scale(1.8)">
          <path 
            d="M2.336 14.904C2.336 15.528 2.64 16.072 3.248 16.536C3.856 17 4.64 17.232 5.6 17.232C6.56 17.232 7.32 17 7.88 16.536C8.44 16.072 8.72 15.456 8.72 14.688C8.72 13.712 8.136 12.904 6.968 12.264L3.416 10.368C1.368 9.264 0.344 7.688 0.344 5.64C0.344 4.328 0.824 3.2 1.784 2.256C2.744 1.312 4.176 0.839999 6.08 0.839999C7.36 0.839999 8.576 1.096 9.728 1.608C10.88 2.12 11.456 2.728 11.456 3.432C11.456 3.704 11.368 4.016 11.192 4.368L10.04 6.576L9.2 6.312V4.296C9.2 3.576 8.88 3.008 8.24 2.592C7.616 2.176 6.864 1.968 5.984 1.968C5.12 1.968 4.456 2.224 3.992 2.736C3.528 3.248 3.296 3.832 3.296 4.488C3.296 5.8 3.888 6.768 5.072 7.392L8.12 9C10.44 10.216 11.6 11.816 11.6 13.8C11.6 15.304 11.032 16.44 9.896 17.208C8.776 17.976 7.352 18.36 5.624 18.36C4.328 18.36 3.08 18.104 1.88 17.592C0.68 17.08 0.08 16.472 0.08 15.768C0.08 15.496 0.168 15.184 0.344 14.832L1.496 12.624L2.336 12.888V14.904Z" 
            fill="currentColor"
          />
        </g>
      </g>
    </g>
  </svg>
);

export default IconLogo;